import * as Scrivito from "scrivito";

function activeObjSearch() {
  const currentHour = new Date();
  currentHour.setMinutes(0, 0, 0);

  return Scrivito.Obj.onAllSites()
    .all()
    .andNot("publishFromDate", "isGreaterThan", currentHour)
    .andNot("publishUntilDate", "isLessThan", currentHour);
}

export default activeObjSearch;
